export default {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  defaultCookieExpiration: process.env.REACT_APP_COOKIE_EXPIRATION,
  recaptchaSiteKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY,
  env: process.env.REACT_APP_ENV,
  usersnapUrl: process.env.REACT_APP_USERSNAP_URL,
};
